import { render, staticRenderFns } from "./QuickPricingModal.vue?vue&type=template&id=68b84536"
import script from "./QuickPricingModal.vue?vue&type=script&lang=js"
export * from "./QuickPricingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports